import { InjectionToken } from '@angular/core';
import { createMocks } from '@backbase/foundation-ang/data-http';
export const CATEGORIES_MANAGEMENT_DATA_HTTP_ANG_CONFIG = new InjectionToken(
  'product-summary-data-http-ang Data Service :: HTTP Config',
);
const examples = [
  {
    "urlPattern": "/client-api/{version}/categories",
    "method": "GET",
    "responses": [
      {
        "status": 500,
        "body": {
          "message": "Description of error"
        },
        "type": "TraitsInternalServerError"
      },
      {
        "status": 400,
        "body": {
          "message": "Bad Request",
          "errors": [
            {
              "message": "Value Exceeded. Must be between {min} and {max}.",
              "key": "common.api.shoesize",
              "context": {
                "max": "50",
                "min": "1"
              }
            }
          ]
        },
        "type": "TraitsBadRequestError"
      },
      {
        "status": 200,
        "body": [
          {
            "categoryId": 1,
            "categoryName": "Home",
            "categoryType": "Expenses",
            "subCategories": [
              {
                "categoryId": 2,
                "categoryName": "Mortgage",
                "categoryType": "Expenses",
                "parentId": 1
              },
              {
                "categoryId": 3,
                "categoryName": "Rent",
                "categoryType": "Expenses",
                "parentId": 1
              }
            ]
          },
          {
            "categoryId": 4,
            "categoryName": "Food & Drinks",
            "categoryType": "Expenses",
            "subCategories": [
              {
                "categoryId": 5,
                "categoryName": "Alcohol & Bars",
                "categoryType": "Expenses",
                "parentId": 4
              },
              {
                "categoryId": 6,
                "categoryName": "Fast Food",
                "categoryType": "Expenses",
                "parentId": 4
              },
              {
                "categoryId": 7,
                "categoryName": "Groceries",
                "categoryType": "Expenses",
                "parentId": 4
              },
              {
                "categoryId": 8,
                "categoryName": "Restaurants",
                "categoryType": "Expenses",
                "parentId": 4
              }
            ]
          },
          {
            "categoryId": 9,
            "categoryName": "Health & Beauty",
            "categoryType": "Expenses",
            "subCategories": [
              {
                "categoryId": 10,
                "categoryName": "Beauty",
                "categoryType": "Expenses",
                "parentId": 9
              },
              {
                "categoryId": 11,
                "categoryName": "Health & Fitness",
                "categoryType": "Expenses",
                "parentId": 9
              }
            ]
          },
          {
            "categoryId": 12,
            "categoryName": "Transportation",
            "categoryType": "Expenses",
            "subCategories": [
              {
                "categoryId": 13,
                "categoryName": "Car",
                "categoryType": "Expenses",
                "parentId": 12
              },
              {
                "categoryId": 14,
                "categoryName": "Public Transport",
                "categoryType": "Expenses",
                "parentId": 12
              }
            ]
          },
          {
            "categoryId": 15,
            "categoryName": "Shopping",
            "categoryType": "Expenses",
            "subCategories": [
              {
                "categoryId": 16,
                "categoryName": "Clothing",
                "categoryType": "Expenses",
                "parentId": 15
              },
              {
                "categoryId": 17,
                "categoryName": "Electronics",
                "categoryType": "Expenses",
                "parentId": 15
              }
            ]
          },
          {
            "categoryId": 18,
            "categoryName": "Hobbies & Entertainment",
            "categoryType": "Expenses"
          },
          {
            "categoryId": 19,
            "categoryName": "Bills & Utilities",
            "categoryType": "Expenses",
            "subCategories": [
              {
                "categoryId": 20,
                "categoryName": "Internet",
                "categoryType": "Expenses",
                "parentId": 19
              },
              {
                "categoryId": 21,
                "categoryName": "Mobile Phone",
                "categoryType": "Expenses",
                "parentId": 19
              },
              {
                "categoryId": 22,
                "categoryName": "Utilities",
                "categoryType": "Expenses",
                "parentId": 19
              }
            ]
          },
          {
            "categoryId": 23,
            "categoryName": "Income",
            "categoryType": "Income",
            "subCategories": [
              {
                "categoryId": 24,
                "categoryName": "Bonus",
                "categoryType": "Income",
                "parentId": 23
              },
              {
                "categoryId": 25,
                "categoryName": "Salary/Wages",
                "categoryType": "Income",
                "parentId": 23
              }
            ]
          },
          {
            "categoryId": 26,
            "categoryName": "Other Income",
            "categoryType": "Income",
            "subCategories": [
              {
                "categoryId": 27,
                "categoryName": "Interest Income",
                "categoryType": "Income",
                "parentId": 26
              },
              {
                "categoryId": 28,
                "categoryName": "Rental Income",
                "categoryType": "Income",
                "parentId": 26
              }
            ]
          },
          {
            "categoryId": 29,
            "categoryName": "Transfers",
            "categoryType": "Transfer"
          },
          {
            "categoryId": 30,
            "categoryName": "Uncategorised",
            "categoryType": "General"
          }
        ],
        "type": "CategoryLIST"
      }
    ]
  },
  {
    "urlPattern": "/client-api/{version}/categories/{id}",
    "method": "GET",
    "responses": [
      {
        "status": 500,
        "body": {
          "message": "Description of error"
        },
        "type": "TraitsInternalServerError"
      },
      {
        "status": 400,
        "body": {
          "message": "Bad Request",
          "errors": [
            {
              "message": "Value Exceeded. Must be between {min} and {max}.",
              "key": "common.api.shoesize",
              "context": {
                "max": "50",
                "min": "1"
              }
            }
          ]
        },
        "type": "TraitsBadRequestError"
      },
      {
        "status": 200,
        "body": {
          "categoryId": 1,
          "categoryName": "Home",
          "categoryType": "Expenses",
          "subCategories": [
            {
              "categoryId": 2,
              "categoryName": "Mortgage",
              "categoryType": "Expenses",
              "parentId": 1
            },
            {
              "categoryId": 3,
              "categoryName": "Rent",
              "categoryType": "Expenses",
              "parentId": 1
            }
          ]
        },
        "type": "CategoryITEM"
      }
    ]
  }
];
export const CategoriesManagementDataHttpMocksProvider = createMocks(examples, CATEGORIES_MANAGEMENT_DATA_HTTP_ANG_CONFIG);
